import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const getCustomField = (): Promise<any> =>
  apiClient(`/v1/integration/org/${getOrgId()}/customFields`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllJiraProjects = (): Promise<any> =>
  apiClient(`/v1/integration/jira/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
